<template>
  <div class="login_block__01">
    <div class="login_mail">
      <h3>ログイン</h3>
        <div class="renew2_flex id">
          <p class="title">ログインID</p>
          <div class="input"><el-input v-model="mailLogin.email"
            type="email"
            autocomplete
            name="mail-link-input"
            placeholder="メールアドレスを入力してください"
            :disabled="loginEmailSending"></el-input></div>
        </div>
        <div class="renew2_flex pw">
          <p class="title">パスワード</p>
          <div class="input"><el-input v-model="mailLogin.passwd"
            type="password"
            autocomplete
            name="mail-link-input"
            placeholder="パスワードを入力してください"
            :disabled="loginEmailSending"></el-input></div>
        </div>
        <el-button type="primary"
          id="email-login-account-dialog"
          class="btn"
          :plain="isPlainButton"
          @click="$eventHub.$emit('login-id-passwd', mailLogin.email, mailLogin.passwd)"
          v-loading="loginEmailSending">ログインする</el-button>
        <p style="text-align:center;"><a href="/repasswd">パスワードを忘れた方はこちら</a></p>
    </div>
    <div class="login_sns">
      <h3>ソーシャルアカウントでログイン</h3>
      <ul class="renew2_flex sns_list">
        <li class="sns_list__item">
          <button class="renew2_flex renew2_sp_flex"
            @click="$firebase.signInGoogle();">
              <img src="/static/renew2_img/google.png" alt="Google">
              <p>Googleでログイン</p>
          </button>
        </li>
        <li class="sns_list__item"
        v-if="$site.appFlag!='b' && getMode != 'production1'">
            <button class="renew2_flex renew2_sp_flex"
            @click="$firebase.signInLine();">
                <img src="/static/renew2_img/line_icon.jpeg" alt="LINE">
                <p>LINEでログイン</p>
            </button>
        </li>
        <li class="sns_list__item">
          <button class="renew2_flex renew2_sp_flex"
            @click="$firebase.signInApple();">
              <img src="/static/renew2_img/appleinc.png" alt="Apple">
              <p>AppleIDでログイン</p>
          </button>
        </li>
        <li class="sns_list__item"
        v-if="getMode != 'production'">
          <button class="renew2_flex renew2_sp_flex"
            @click="$firebase.signInFacebook();">
              <img src="/static/renew2_img/facebook.png" alt="Facebook">
              <p>Facebookでログイン</p>
          </button>
        </li>
      </ul>
      <div class="sns_list__link" v-if="$site.appFlag!='b'">
          <h3>メールに登録リンクを送る</h3>
          <div class="renew2_flex maillink">
              <div class="input"><el-input v-model="mailLogin.email"
              type="email"
              autocomplete
              name="mail-link-input"
              placeholder="メールアドレスを入力してください"
              :disabled="loginEmailSending"></el-input></div>
          </div>
          <el-button type="primary"
            id="email-login-account-dialog"
            class="maillink-btn"
            :plain="isPlainButton"
            @click="mailSubmit"
            v-loading="loginEmailSending">メールでリンクを送る</el-button>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      mailLogin: {
        email: ''
      },
      mailLoginRules: {
        email: [
          {
            required: true,
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
  },
  methods: {
    resetloginEmail: function () {
      this.mailLogin.email = ''
      this.loginEmailSending = false
      // this.$refs['mailLoginForm'].resetFields()
    },
    mailSubmit: function () {
      const app = this
      // this.$refs['mailLoginForm'].validate(async valid => {
      //   if (!valid) {
      //     return
      //   }
      app.$firebase.signInEmail(app.mailLogin.email)
      app.loginEmailSending = true
      // })
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
  }
}
</script>



